@if (label) {
    <label for="select-{{name}}" id="select-label-{{name}}">
        {{ label }}
        @if (required) {
            *
        }
    </label>
}

<select
        id="select-{{name}}"
        class="form-select"
        required
        (change)="onChange($event)"
        [attr.aria-labelledby]="label ? 'select-label-' + name : null"
        aria-required="true"
>
    @if (!value) {
        <option value="">{{ placeholder }}</option>
    }

    @for (option of options; track option.value; let i = $index) {
        <option
                id="{{name}}-option-{{i}}"
                [value]="option.value"
                [selected]="option.value === value"
        >{{ option.label }}</option>
    }
</select>


